'use client';

import type React from 'react';
import { createContext, type RefObject, useContext, useRef } from 'react';

interface ScrollContextType {
  scrollContainerRef: RefObject<HTMLDivElement | null>;
}

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const useScrollContainer = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScrollContainer must be used within a ScrollProvider');
  }
  return context;
};

export const ScrollProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return <ScrollContext.Provider value={{ scrollContainerRef }}>{children}</ScrollContext.Provider>;
};
